/**
 * Hover styling for outline Buttons that should pick up the tenant's colour.
 *
 * The outline variant's own hover is `hover:bg-accent hover:text-accent-foreground`,
 * and neither of those tokens is re-themed by theme-bridge (it overrides
 * primary / ring / action / action-light / brand-secondary only), so every
 * tenant hovered to the same fixed blue.
 *
 * No border colour in here: v2.css's unlayered `border-width: 0` means an
 * outline Button has no border to recolour, its edge is the variant's shadow.
 */
export const tenantHoverClassName = "hover:bg-primary/10 hover:text-primary";

/** The same, for a button whose action is destructive. */
export const destructiveHoverClassName =
  "hover:bg-destructive/10 hover:text-destructive";
